import { pathAPI } from "../utils/pathApi";
import { useAPI } from "./api";

export const useGetCategory = ({
  page = 0,
  size = 10,
}: {
  page: number;
  size: number;
}) => {
  const { data, error, loading, mutate } = useAPI<{
    data: Category[];
    total: number;
  }>(pathAPI.category, true, { page, size });
  return [
    {
      data: data?.data || null,
      error,
      isLoading: loading,
      total: data?.total || 0,
    },
    { mutate },
  ] as const;
};

export const useCategoryDetail = (id = "") => {
  const { data, error, loading, mutate } = useAPI<{
    data: CategoryDetail;
    total: number;
  }>(`${pathAPI.categoryDetail}/${id}`, true);

  return [
    { data: data?.data || null, error, isLoading: loading },
    { mutate },
  ] as const;
};

export const useCategoryDetailWithTranslations = (id = "") => {
  const { data, error, loading, mutate } = useAPI<{
    data: {
      category: CategoryDetail;
      translations: Array<{
        translation_id: number;
        translation_name: string;
        language_id: number;
        language_code: string;
      }>;
    }
  }>(`${pathAPI.categoryDetail}/${id}/translations`, true);

  return [
    { 
      category: data?.data?.category || null, 
      translations: data?.data?.translations || [],
      error, 
      isLoading: loading 
    },
    { mutate },
  ] as const;
};

export const useChildCategoryWithTranslations = (childId = "") => {
  const { data, error, loading, mutate } = useAPI<{
    data: {
      category: CategoryChild;
      translations: Array<{
        translation_id: number;
        translation_name: string;
        language_id: number;
        language_code: string;
      }>;
    }
  }>(`${pathAPI.categoryDetail}/${childId}/translations`, true);

  return [
    { 
      childCategory: data?.data?.category || null, 
      translations: data?.data?.translations || [],
      error, 
      isLoading: loading 
    },
    { mutate },
  ] as const;
};
